import type { Exam, QuestionType } from '../types'

export type ExamBlueprint = {
  code: Exam
  label: string
  mathFocus: string
  fullExam: { questions: number; minutes: number }
  miniMock: { questions: number; minutes: number }
  /** A scoped module when SangMath does not yet cover every official section. */
  mathPilot?: { questions: number; minutes: number }
  /** Curated IDs make the mini mock representative without coupling its logic to a page. */
  miniMockQuestionIds?: string[]
  supportedQuestionTypes: QuestionType[]
  enabled: boolean
  contentStatus: 'ready' | 'awaiting-authorized-source'
}

/**
 * Assessment structure belongs here, never in page components. TSA stays visible
 * but disabled until original/licensed items are available.
 */
export const examBlueprints: Record<Exam, ExamBlueprint> = {
  HSA: {
    code: 'HSA', label: 'ĐGNL Hà Nội (HSA)', mathFocus: 'Toán học và xử lý số liệu',
    fullExam: { questions: 50, minutes: 75 }, miniMock: { questions: 10, minutes: 15 },
    // 7 four-choice + 3 numeric; 20% M1, 60% M2, 20% M3. All are original SangMath items.
    miniMockQuestionIds: [
      'HSA-ORIG-2026-01', 'HSA-ORIG-2026-04', 'HSA-ORIG-2026-11', 'HSA-ORIG-2026-14', 'HSA-ORIG-2026-17',
      'HSA-ORIG-2026-22', 'HSA-ORIG-2026-31', 'HSA-ORIG-2026-36', 'HSA-ORIG-2026-41', 'HSA-ORIG-2026-46',
    ],
    supportedQuestionTypes: ['single-choice', 'numeric'], enabled: true, contentStatus: 'ready',
  },
  VACT: {
    code: 'VACT', label: 'ĐGNL ĐHQG TP.HCM (V-ACT)', mathFocus: 'Toán học, logic và phân tích dữ liệu',
    fullExam: { questions: 42, minutes: 150 }, miniMock: { questions: 10, minutes: 15 },
    supportedQuestionTypes: ['single-choice'], enabled: true, contentStatus: 'ready',
  },
  TSA: {
    code: 'TSA', label: 'TSA Toán chuyên sâu (Pilot)', mathFocus: 'Tư duy Toán học · 40 câu/60 phút',
    fullExam: { questions: 100, minutes: 150 }, miniMock: { questions: 10, minutes: 15 }, mathPilot: { questions: 40, minutes: 60 },
    supportedQuestionTypes: ['single-choice', 'numeric', 'true-false'], enabled: true, contentStatus: 'ready',
  },
}
